import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ConnectedIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7 2C7 1.44772 7.44772 1 8 1H14C14.5523 1 15 1.44772 15 2V3C15 3.55228 14.5523 4 14 4H8C7.44772 4 7 3.55228 7 3V2Z"
		></path>
		<path
			fill="currentColor"
			d="M10.25 5H11.75V6.5C11.75 7.74264 10.7426 8.75 9.5 8.75H6.5C6.08579 8.75 5.75 9.08579 5.75 9.5V11H4.25V9.5C4.25 8.25736 5.25736 7.25 6.5 7.25H9.5C9.91421 7.25 10.25 6.91421 10.25 6.5V5Z"
		></path>
		<path
			fill="currentColor"
			d="M2 12C1.44772 12 1 12.4477 1 13V14C1 14.5523 1.44772 15 2 15H8C8.55229 15 9 14.5523 9 14V13C9 12.4477 8.55229 12 8 12H2Z"
		></path>
	</svg>
))
